module.exports = __webpack_public_path__ + "img/54ne.a3210500.svg";